"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaskInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _ui = require("../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MaskInput = function MaskInput(_ref) {
  var inputProps = _ref.inputProps,
    control = _ref.control;
  var _useController = (0, _reactHookForm.useController)({
      name: inputProps.name,
      control: control
    }),
    _useController$field = _useController.field,
    onChange = _useController$field.onChange,
    onBlur = _useController$field.onBlur,
    value = _useController$field.value,
    _useController$fieldS = _useController.fieldState,
    invalid = _useController$fieldS.invalid,
    error = _useController$fieldS.error;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    allowNegative: false,
    customInput: _ui.Input,
    displayType: "input",
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    invalid: invalid,
    format: inputProps.mask,
    onValueChange: function onValueChange(_ref2) {
      var value = _ref2.value;
      if (onChange) onChange({
        target: {
          value: value
        }
      });
    }
  }), error && /*#__PURE__*/_react.default.createElement(_ui.FormFeedback, {
    valid: false
  }, error === null || error === void 0 ? void 0 : error.message));
};
exports.MaskInput = MaskInput;